export enum AmplitudeProductType {
  INSTALLMENTS = 'installments',
  ECOMMERCE = 'ecommerce',
  INSTORE = 'instore',
  INSTORE_CONSUMER = 'instore_consumer',
  UNKNOWN_WILLINGNESS = 'unknown_willingness'
}
